import { render, staticRenderFns } from "./UploadMultiple.vue?vue&type=template&id=b2d70e3c&scoped=true"
import script from "./UploadMultiple.vue?vue&type=script&lang=js"
export * from "./UploadMultiple.vue?vue&type=script&lang=js"
import style0 from "./UploadMultiple.vue?vue&type=style&index=0&id=b2d70e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d70e3c",
  null
  
)

export default component.exports